/* eslint-disable no-shadow */
export enum ValidationRules {
	REQUIRED = 'required',
	PATTERN = 'pattern',
}
